import { defineComponent as _defineComponent } from 'vue'
import { computed, inject, Ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  ConclusionStep,
  ListDisplay,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';

import { ICreatePortfolio } from '@/modules/catalog/services/variable-income';


export default /*#__PURE__*/_defineComponent({
  __name: 'Conclusion',
  setup(__props) {

const router = useRouter();

const conclusionData = inject('conclusionData') as Ref<ICreatePortfolio>;
const amountFormatted = inject('amountFormatted') as Ref<string>;
const amountValue = inject('amountValue') as Ref<number>;

const description = computed(() => {
  return amountValue.value > 0
    ? `Aplicação prevista para ${conclusionData.value.expectedInvestmentDate}`
    : '';
});

const details = computed(() => {
  return [
    {
      label: 'Valor do investimento',
      value: `R$ ${amountFormatted.value}`
    },
    {
      label: 'Origem',
      value: 'Conta digital'
    },
    {
      label: 'Destino',
      value: conclusionData.value.portfolioName
    }
  ];
});

function goToPortfolio() {
  router.push({
    name: 'wealthIndexPortfolio',
    params: { portfolioId: conclusionData.value.portfolioId },
    query: { tab: 'orders' }
  });
}

return { __sfc: true,router, conclusionData, amountFormatted, amountValue, description, details, goToPortfolio, ConclusionStep, ListDisplay, ButtonPrimary }
}

})